import { Input, Modal, Space, Table } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { partnerApprovalSelector } from "../../feature/partner-approval/partnerApprovalSelector";
import {
  acceptPartnerRequest,
  getPartnerApprovalRequest,
  rejectPartnerRequest,
  removePartnerRequest,
} from "../../feature/partner-approval/partnerApprovalSlice";
import { appConfig } from "../../utils/appConfig";

const WaitingDecision = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(appConfig.PAGE_SIZE);
  const [displayRemovePartner, setDisplayRemovePartner] = useState(false);
  const [displayRejectPartner, setDisplayRejectPartner] = useState(false);
  const [selectedRemovePartner, setSelectedRemovePartner] = useState();
  const [selectedRejectPartner, setSelectedRejectPartner] = useState();
  const [note, setNote] = useState("");

  const {
    listPartnerApproval,
    total,
    isAcceptPartner,
    isRejectPartner,
    isRemovePartner,
  } = useSelector(({ partnerApprovalState }) =>
    partnerApprovalSelector(partnerApprovalState)
  );
  const dispatch = useDispatch();

  const columns = useMemo(() => {
    const result = [
      {
        title: "Referral Partner Name",
        dataIndex: "name",
        key: "name",
        render: (_, item) => `${item.firstName || ""} ${item.lastName || ""}`,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Created On",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (time) => moment(time).format("DD MMM YYYY"),
      },
      {
        title: "Pre qualification answers",
        dataIndex: "preQualificationAnswers",
        key: "preQualificationAnswers",
        render: (values) => {
          if (!values) return "";
          return (
            <ul className="pre-qualification-ul">
              {values[0].content.split("\n").map((value, key) => (
                <li key={key}>- {value}</li>
              ))}
            </ul>
          );
        },
      },
      {
        title: "Action",
        key: "action",
        render: (_, item) => (
          <Space size="middle">
            <span
              className="link-pointer"
              onClick={() => onAcceptPartner(item)}
            >
              Accept
            </span>
            <span
              className="pointer ant-typography ant-typography-danger"
              onClick={() => onRejectPartner(item)}
            >
              Reject
            </span>
            <span
              className="pointer ant-typography ant-typography-danger"
              onClick={() => onDeletePartner(item)}
            >
              Delete
            </span>
          </Space>
        ),
      },
    ];
    return result;
    // eslint-disable-next-line
  }, []);

  const onAcceptPartner = (data) => {
    dispatch(acceptPartnerRequest(data));
  };

  const onRejectPartner = (data) => {
    setDisplayRejectPartner(true);
    setSelectedRejectPartner(data);
  };

  const onDeletePartner = (data) => {
    setDisplayRemovePartner(true);
    setSelectedRemovePartner(data);
  };

  const onConfirmRejectPartner = () => {
    selectedRejectPartner &&
      dispatch(rejectPartnerRequest({ id: selectedRejectPartner._id, note }));
    setDisplayRejectPartner(false);
    setNote("");
  };

  const onConfirmRemovePartner = () => {
    selectedRemovePartner &&
      dispatch(removePartnerRequest(selectedRemovePartner));
    setDisplayRemovePartner(false);
  };

  const loadData = (newPage, sizeChanger) => {
    const limit = sizeChanger || pageSize;
    setPage(newPage);
    setPageSize(sizeChanger);
    dispatch(
      getPartnerApprovalRequest({
        limit,
        offset: (newPage - 1) * limit,
        status: "inactive",
      })
    );
  };

  useEffect(() => {
    if (total === 0 && page > 1) {
      loadData(page - 1, pageSize);
    } else {
      loadData(page, pageSize);
    }
    // eslint-disable-next-line
  }, [total]);

  return (
    <div>
      <div className="mt-25">
        <Table
          className="mt-5"
          columns={columns}
          dataSource={listPartnerApproval}
          bordered
          pagination={{
            showTotal: (total) => `Total ${total} results`,
            defaultPageSize: appConfig.PAGE_SIZE,
            pageSize,
            defaultCurrent: 1,
            current: page,
            showSizeChanger: true,
            pageSizeOptions: [appConfig.PAGE_SIZE, 25, 50].sort(
              (a, b) => a - b
            ),
            total,
            onChange: (page, sizeChanger) => loadData(page, sizeChanger),
          }}
          rowKey="_id"
          loading={isAcceptPartner || isRejectPartner || isRemovePartner}
        />
      </div>
      {displayRemovePartner && (
        <Modal
          title="Are you sure?"
          visible={true}
          width={"50%"}
          className="modal-w-600"
          onOk={onConfirmRemovePartner}
          onCancel={() => {
            setDisplayRemovePartner(false);
            setSelectedRemovePartner(undefined);
          }}
        >
          <p>
            Do you really want to delete this partner? This process cannot be
            undone.
          </p>
        </Modal>
      )}
      {displayRejectPartner && (
        <Modal
          title="Note"
          visible={true}
          width={"50%"}
          className="modal-w-600"
          onOk={onConfirmRejectPartner}
          onCancel={() => {
            setDisplayRejectPartner(false);
            setSelectedRejectPartner(undefined);
            setNote("");
          }}
        >
          <Input.TextArea
            onChange={(e) => setNote(e.target.value)}
          ></Input.TextArea>
        </Modal>
      )}
    </div>
  );
};

export default WaitingDecision;
